import { combineReducers } from "redux";
import FamilyDetails from "./FamilyDetails";
import { ERevampReportReducers } from "@adapters/presenters/action-interfaces/Reports/DashboardSummary";
import createNamedWrapperReducer from "@redux/feature/Markets/Equity/wrapperReducer";
export default combineReducers({
    familyDetails: createNamedWrapperReducer(FamilyDetails, ERevampReportReducers.FamilyTagging),
    // consolidatedDetails: createNamedWrapperReducer<
    //   IONEPlatFormMainRoot<IConsolidatedDetailsData>,
    //   IOnePlatformActionPayload<IConsolidatedDetailsData>
    // >(ConsolidatedDetails, "consolidatedDetails"),
});
